import FreeText from '@algbra/ui/components/FreeText/FreeText'
import GreyBox from '@algbra/ui/components/GreyBox/GreyBox'
import IconLink from '@algbra/ui/components/IconLink/IconLink'
import { IconNameType } from '@algbra/ui/icons'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import { mapIndexed } from 'rambdax'
import { ReactNode } from 'react'

export type ContactInfoLink = {
  label: string
  iconType: IconNameType
  url: string
}
export type ZoneContactBoxLinksProps = {
  __typename: 'StrapiGQL_ComponentZonesContactBox'
  title: ReactNode
  description?: ReactNode
  links?: ContactInfoLink[]
  image?: GatsbyResolvedAsset
  footnote?: string
}
export default function ZoneContactBoxLinks(props: ZoneContactBoxLinksProps) {
  const { title, description, links, image, footnote } = props
  return (
    <GreyBox title={title} image={image} footNote={footnote}>
      <FreeText color="secondary" innerHTML={description}>
        {description}
      </FreeText>
      {mapIndexed(
        ({ iconType, label, url }, index) => (
          <IconLink
            iconName={iconType}
            key={`key-${index}`}
            to={url}
            isExternal={true}
          >
            {label}
          </IconLink>
        ),
        links || []
      )}
    </GreyBox>
  )
}
